
export const cleanUpAbout = (rawData) => {

    const {sys, fields} =rawData
    const {id}= sys
    const aboutTitle = fields.title
    const aboutContent = fields.content
    const aboutImage = fields.image.fields.file.url
    let cleanAbout = {id, aboutTitle, aboutContent, aboutImage}
    return cleanAbout
    

}

export const cleanUpSlides = (rawData) => {

    const cleanslides = rawData.map((slide) =>{

        const {sys, fields} =slide
        const {id}= sys
        const slideTitle = fields.title
        const slideDescription = fields.description
        const slideBg = fields.image.fields.file.url
        const updatedSlide = {id, slideTitle, slideDescription, slideBg}
        return updatedSlide
    })

    return cleanslides
}

export const cleanUpCategories = (rawData) => {

    const cleanCategories = rawData.map((category) =>{

        const {sys, fields} =category
        const {id} = sys
        const categoryTitle = fields.title
        const categoryImage = fields.image.fields.file.url
        const cleanedCategories = {id, categoryTitle, categoryImage}
        return cleanedCategories
    })
    return cleanCategories
    

}

export const cleanUpEntrees = (rawData) => {

    const cleanEntrees = rawData.map((category) =>{

        const {sys, fields} =category
        const {id} = sys
        const recipeTitle = fields.recipeName
        const recipeImage = fields.recipePicture.fields.file.url
        const recipeIngredients = fields.recipeItems
        const recipeDirections = fields.recipeDirections
        const recipeTime = fields.totalTime
        const mealType = fields.mealType
        const cleanedEntrees = {id, recipeTitle, recipeImage, recipeIngredients,recipeDirections, recipeTime, mealType}
        return cleanedEntrees
    })
    return cleanEntrees
    

}